const firebaseConfig = {
    apiKey: "AIzaSyAupvwOA_eAI-BLiQSHkqPUH7WhlF-OIpY",
    authDomain: "ema-john-simpleshop.firebaseapp.com",
    projectId: "ema-john-simpleshop",
    storageBucket: "ema-john-simpleshop.appspot.com",
    messagingSenderId: "396879061833",
    appId: "1:396879061833:web:dfe09d14f0f9746432f098"
};
  
export default firebaseConfig;